import React from 'react';
import { useIntl } from 'react-intl';
import { StyledModal } from '../../styled/StyledModal';
import ModalContent from '../ModalContent';
import { useRemoveDocumentRole } from '../../helpers/hooks';

export interface IModalProps {
  isOpen: boolean;
  toggle: () => void;
  centered?: boolean;
  alert?: React.ReactNode;
  header?: string | React.ReactElement;
  body?: string | React.ReactElement | React.ReactElement[];
  footer?: string | React.ReactElement | false;
  backdrop?: boolean | 'static';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  headingTag?: string;
  className?: string;
  modalClassName?: string;
  returnFocusAfterClose?: boolean;
  showCloseButton?: boolean;
  ariaLabel?: string;
  ariaDescribedBy?: string;
}

const Modal = ({
  isOpen,
  toggle,
  centered,
  header,
  body,
  footer,
  backdrop = 'static',
  size = 'md',
  headingTag,
  alert,
  className,
  modalClassName,
  returnFocusAfterClose = true,
  showCloseButton = true,
  ariaLabel,
  ariaDescribedBy,
}: IModalProps): JSX.Element => {
  const intl = useIntl();
  useRemoveDocumentRole(isOpen);

  return (
    <StyledModal
      returnFocusAfterClose={returnFocusAfterClose}
      $rtl={intl.bidi}
      isOpen={isOpen}
      toggle={toggle}
      centered={centered}
      backdrop={backdrop}
      size={size}
      data-test-id="Modal"
      className={className}
      modalClassName={modalClassName}
      $showCloseButton={showCloseButton}
      {...(ariaLabel && { 'aria-label': ariaLabel })}
      {...(ariaDescribedBy && { 'aria-describedby': ariaDescribedBy })}
    >
      <ModalContent
        toggle={toggle}
        header={header}
        body={body}
        footer={footer}
        headingTag={headingTag}
        alert={alert}
        showCloseButton={showCloseButton}
      />
    </StyledModal>
  );
};

export default Modal;
